import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resolveLocalizedText } from '../../../../utils';
import classNames from 'classnames';
import { ChangeContactView } from '../../components/ChangeContactView';
import EditableInput from '../../components/EditableInput';
import {
  getChangeEmailLabels,
  getChangeEmailStepContext,
  getSelectedList,
  getIsLoading,
} from '../../selectors/changeEmailSelector';
import {
  getChangeContactPolicyCardsLength,
  getSelectedPolicy,
} from '../../selectors/changeContactSelector';
import './style.scss';
import { sendChangeEmailOtpRequest } from '../../actions/changeEmailAction';
import { goto } from '../../../../actions/historyActions';
import { getNewEmail, getForm } from '../../selectors/changeEmailSelector';
import { updateFormStates } from '../../actions/changeEmailAction';
import { contactPermissionPolicy } from '../../types/changeContactService';
import { sortPermissionPolicies } from '../../utils';
import _ from 'lodash';
import EmmaErrorModal from '../../../../components/EmmaErrorModal';
import LongLoadingView from '../../../../components/LongLoadingView';
import { POLICIES } from '../../constants/constants';
import { ENTITY_CODE } from '../../../../constants/constants';
import { passPath } from '../../../../utils/emmaUrlConverter';
import { EmmaCheckbox } from '@axa-asia/emma-stylesheet';

interface Form {
  agreeNotify?: boolean;
  agreeUseOfData?: boolean;
  agreeProvidedValidData?: boolean;
  agreeRevokeEmail?: boolean;
}
export interface ReviewEmailContainerProps {
  changeEmailLabels: any;
  changeEmailStepContext: any;
  newEmail: string;
  onSendOtpRequest: () => any;
  selectedPolicy: any;
  selectedList: contactPermissionPolicy[];
  form: Form;
  onUpdateFormStates: (payload: { [prop: string]: any }) => void;
  isLoading: boolean;
  policies: number;
}

export interface ReviewEmailContainerState {
  isFormValid: boolean;
}

export class ReviewEmailContainer extends Component<
  ReviewEmailContainerProps,
  ReviewEmailContainerState
> {
  constructor(props: ReviewEmailContainerProps) {
    super(props);
    this.state = {
      isFormValid: false,
    };
  }

  onGoNext = () => {
    const { onSendOtpRequest } = this.props;
    // const { agreeNotify } = this.state;

    // updateEmailCustState(
    //   cicCustKey,
    //   JSON.stringify({
    //     DM2: agreeNotify === "true" ? "Y" : "N",
    //   }),
    //   "emma"
    // );
    onSendOtpRequest();
  };

  onGoBackToEdit = () => {
    // const backIndex = getHistoryIndexById(CHANGE_EMAIL_EDIT_ID);
    // historyGo(backIndex);
    goto(passPath('emma-customer-profile/changeemail', '/renewalupdate'));
  };

  validateForm() {
    const { selectedPolicy, form } = this.props;
    const isFormValid = Object.keys(form)
      .filter((k) =>
        selectedPolicy.suspensionFlagEmail === 'S'
          ? true
          : k !== 'agreeRevokeEmail',
      )
      .every((key: keyof Form) => key === 'agreeNotify' || form[key]);
    this.setState({ isFormValid });
  }

  componentDidMount() {
    const { selectedPolicy } = this.props;
    if (_.isEmpty(selectedPolicy)) {
      goto('emma-change-contact', undefined, undefined, true);
      return;
    }
    this.validateForm();
  }

  componentDidUpdate(prevProps: Readonly<ReviewEmailContainerProps>): void {
    if (this.props.form !== prevProps.form) {
      this.validateForm();
    }
  }

  render() {
    const {
      selectedList,
      changeEmailLabels,
      changeEmailStepContext,
      selectedPolicy,
      newEmail,
      isLoading,
      form,
      policies,
    } = this.props;
    const { isFormValid } = this.state;
    const editEmail = changeEmailLabels.editEmail
      ? resolveLocalizedText(changeEmailLabels.editEmail)
      : '';
    const resolvedStepContext = resolveLocalizedText(
      changeEmailStepContext,
    ) as any;
    const reviewEmailHeading = changeEmailLabels.reviewEmailHeading
      ? resolveLocalizedText(changeEmailLabels.reviewEmailHeading)
      : '';
    const reviewEmailEbAlert = changeEmailLabels.reviewEmailEbAlert
      ? resolveLocalizedText(changeEmailLabels.reviewEmailEbAlert)
      : '';
    const reviewEmailLabel = changeEmailLabels.reviewEmailLabel
      ? resolveLocalizedText(changeEmailLabels.reviewEmailLabel)
      : '';
    const reviewPolicies = changeEmailLabels.reviewPolicies
      ? resolveLocalizedText(changeEmailLabels.reviewPolicies)
      : '';
    const agreeNotification = changeEmailLabels.agreeNotification
      ? resolveLocalizedText(changeEmailLabels.agreeNotification)
      : '';
    const agreeUseOfData = changeEmailLabels.agreeUseOfData
      ? resolveLocalizedText(changeEmailLabels.agreeUseOfData)
      : '';
    const yesLabel = changeEmailLabels.yes
      ? resolveLocalizedText(changeEmailLabels.yes)
      : '';
    const agreeProvidedValidData = changeEmailLabels.agreeProvidedValidData
      ? resolveLocalizedText(changeEmailLabels.agreeProvidedValidData)
      : '';
    const agreeRevokeEmailLabel = changeEmailLabels.agreeRevokeEmailLabel
      ? resolveLocalizedText(changeEmailLabels.agreeRevokeEmailLabel)
      : '';
    const verifyBtn = changeEmailLabels.verifyBtn
      ? resolveLocalizedText(changeEmailLabels.verifyBtn)
      : '';
    const hasEB = [selectedPolicy, ...selectedList].some(
      (policy) => policy.entityCode === ENTITY_CODE.EHK,
    );

    return (
      <div className="Review-Email">
        <ChangeContactView
          pageName={editEmail}
          stepContext={resolvedStepContext}
          activeIndex={1}
        >
          {isLoading ? (
            <LongLoadingView isShowText={policies > POLICIES} />
          ) : (
            <div className="emma-stylesheet-grid-system">
              <div className="change-contact-heading2">
                {reviewEmailHeading}
              </div>
              <div className="Review-Email__editable-input">
                <EditableInput
                  label={reviewEmailLabel}
                  id="reviewEmailLabel"
                  value={newEmail}
                  onClickIcon={this.onGoBackToEdit}
                  disabled
                />
                {hasEB && (
                  <div className="change-contact-text change-contact-text--light">
                    {reviewEmailEbAlert}
                  </div>
                )}
              </div>
              <div className="change-contact-label--bold">{reviewPolicies}</div>
              <div className="change-contact-label">
                <ul>
                  {sortPermissionPolicies([
                    selectedPolicy,
                    ...selectedList,
                  ]).map(({ planName, policyName }, idx) => {
                    return (
                      <li key={idx}>
                        {resolveLocalizedText(planName || policyName || '')}
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="Review-Email__disclaimer row">
                <div className="col-12">
                  <div className="row">
                    <EmmaCheckbox
                      content={
                        <div
                          className="Review-Email__disclaimer-title col-12 change-contact-text"
                          dangerouslySetInnerHTML={{
                            __html: memoSanitize(agreeUseOfData),
                          }}
                        ></div>
                      }
                      checked={form.agreeUseOfData}
                      onChange={(checked) =>
                        this.props.onUpdateFormStates({
                          agreeUseOfData: checked,
                        })
                      }
                      gaText={yesLabel ? resolveLocalizedText(yesLabel) : ''}
                    ></EmmaCheckbox>
                  </div>
                </div>
              </div>
              <div className="Review-Email__disclaimer row">
                <div className="col-12">
                  <div className="row">
                    <EmmaCheckbox
                      content={
                        <div
                          className="Review-Email__disclaimer-title col-12 change-contact-text"
                          dangerouslySetInnerHTML={{
                            __html: memoSanitize(agreeNotification),
                          }}
                        ></div>
                      }
                      checked={form.agreeNotify}
                      onChange={(checked) =>
                        this.props.onUpdateFormStates({
                          agreeNotify: checked,
                        })
                      }
                      gaText={yesLabel ? resolveLocalizedText(yesLabel) : ''}
                    ></EmmaCheckbox>
                  </div>
                </div>
              </div>
              <div className="Review-Email__disclaimer row">
                <div className="col-12">
                  <div className="row">
                    <EmmaCheckbox
                      content={
                        <div
                          className="Review-Email__disclaimer-title col-12 change-contact-text"
                          dangerouslySetInnerHTML={{
                            __html: memoSanitize(agreeProvidedValidData),
                          }}
                        ></div>
                      }
                      checked={form.agreeProvidedValidData}
                      onChange={(checked) =>
                        this.props.onUpdateFormStates({
                          agreeProvidedValidData: checked,
                        })
                      }
                      gaText={yesLabel ? resolveLocalizedText(yesLabel) : ''}
                    ></EmmaCheckbox>
                  </div>
                </div>
              </div>
              {selectedPolicy.suspensionFlagEmail === 'S' && (
                <div className="Review-Email__disclaimer row">
                  <div className="col-12">
                    <div className="row">
                      <EmmaCheckbox
                        content={
                          <div
                            className="Review-Email__disclaimer-title col-12 change-contact-text"
                            dangerouslySetInnerHTML={{
                              __html: memoSanitize(agreeRevokeEmailLabel),
                            }}
                          ></div>
                        }
                        checked={form.agreeRevokeEmail}
                        onChange={(checked) =>
                          this.props.onUpdateFormStates({
                            agreeRevokeEmail: checked,
                          })
                        }
                        gaText={yesLabel ? resolveLocalizedText(yesLabel) : ''}
                      ></EmmaCheckbox>
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                <button
                  className={classNames({
                    'Review-Email__button': true,
                    'emma-stylesheet-primary-default-button': isFormValid,
                    'emma-stylesheet-primary-secondary-default-disabled-button':
                      !isFormValid,
                  })}
                  data-enable-ga
                  data-ga-type="button"
                  onClick={this.onGoNext}
                  disabled={!isFormValid}
                >
                  {verifyBtn}
                </button>
              </div>
            </div>
          )}
        </ChangeContactView>
        <EmmaErrorModal />
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const changeEmailLabels = getChangeEmailLabels(state);
    const changeEmailStepContext = getChangeEmailStepContext(state);
    const newEmail = getNewEmail(state);
    const selectedList = getSelectedList(state);
    const selectedPolicy = getSelectedPolicy(state);
    const form = getForm(state);
    const isLoading = getIsLoading(state);
    const policies = getChangeContactPolicyCardsLength(state);

    return {
      form,
      changeEmailLabels,
      changeEmailStepContext,
      newEmail,
      selectedList,
      selectedPolicy,
      isLoading,
      policies,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onUpdateFormStates: (payload: { [prop: string]: any }) =>
        dispatch(updateFormStates(payload)),
      onSendOtpRequest: () => dispatch(sendChangeEmailOtpRequest()),
    };
  }
}

export default connect(
  ReviewEmailContainer.mapStateToProps,
  ReviewEmailContainer.mapDispatchToProps,
)(ReviewEmailContainer);
